export const NAME = 'category';

/**
 * Here goes the actionTypes
 */
export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';
export const FAILURE_CATEGORIES = 'FAILURE_CATEGORIES';



// WEBPACK FOOTER //
// ./src/services/category/constants.js